import type { ModalProps } from '@nuxt/ui'

const calendarModal: NonNullable<ModalProps['ui']> = {
  content: 'w-full sm:max-w-xl',
}
export { calendarModal }
